@if (user$ | async; as user) {
<div class="ml-6">
    <div sag-ui-avatar-base>
        <div sag-ui-avatar>{{ user.firstName[0].toUpperCase() }}{{ user.lastName[0].toUpperCase() }}</div>
        <div>
            <div sag-ui-avatar-name>{{ user.firstName }} {{ user.lastName }}</div>
            <div sag-ui-avatar-org>{{ user.email }}</div>
        </div>
    </div>
</div>
}
